import { Tabs, Carousel } from '@materializecss/materialize';

const initCarousel = (carousel, index = 0) => {
  Carousel.init(carousel, {
    fullWidth: true,
    indicators: true,
    duration: 0
  });

  // Get sibling navigation buttons
  const prevBtn = carousel.parentElement.querySelector('.prev');
  const nextBtn = carousel.parentElement.querySelector('.next');
  const instance = Carousel.getInstance(carousel);

  if (index) {
    instance.set(index);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => instance?.prev());
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => instance?.next());
  }
};

function materializeFunctions() {
  // Initialize Hero Carousel
  const heroCarousels = document.querySelectorAll('.hero-carousel');
  heroCarousels.forEach((carousel) => {
    Carousel.init(carousel, {
      fullWidth: true,
      indicators: true,
      duration: 0
    });
  });

  // Add click event listeners for Hero Carousel navigation
  const prevBtns = document.querySelectorAll('.prev');
  const nextBtns = document.querySelectorAll('.next');

  prevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      heroCarousels.forEach((carousel) => {
        const instance = Carousel.getInstance(carousel);
        instance?.prev();
      });
    });
  });

  nextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      heroCarousels.forEach((carousel) => {
        const instance = Carousel.getInstance(carousel);
        instance?.next();
      });
    });
  });

  // Initialize Ship Carousel
  const shipCarousels = document.querySelectorAll('.ship-carousel');
  const shipCarouselItems = document.querySelectorAll('.carousel-item').length;

  if (shipCarouselItems > 0) {
    shipCarousels.forEach((carousel) => initCarousel(carousel));
    window.addEventListener('init-ship-modal-carousel', (e) => {
      const shipModalCarousels = document.querySelectorAll('.ship-modal-carousel');
      shipModalCarousels.forEach((carousel) => initCarousel(carousel, e.detail));
    });
  }

  // Initialize Tabs
  const tabs = document.querySelectorAll('.tabs');
  tabs.forEach((tab) => {
    Tabs.init(tab);
  });
}

export default materializeFunctions;
